<template functional>
  <div class="prices">
    <span v-if="props.onSale" class="original-price">
      {{ props.originalPrice }}
    </span>
    <span class="sell-price">{{ props.price }}</span>
    <span v-if="props.onSale" class="sale-text">
      {{ props.saleText }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * Original price
     *
     * @type {string}
     */
    originalPrice: {
      type: String,
      default: ''
    },
    /**
     * Sell price
     *
     * @type {string}
     */
    price: {
      type: String,
      required: true
    },
    /**
     * Sale text
     *
     * @type {string}
     */
    saleText: {
      type: String,
      default: ''
    },
    /**
     * Is variant on sale?
     *
     * @type {boolean}
     */
    onSale: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.prices {
  .original-price,
  .sell-price,
  .sale-text {
    margin-right: 5px;
  }

  .original-price {
    font-weight: 300;
    text-decoration: line-through;
  }

  .sell-price {
    font-weight: 700;
  }

  .sale-text {
    text-transform: uppercase;
    font-weight: 700;
    color: $red;
  }
}
</style>
